import React, { useEffect, useState } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import CartDetailsComponent from "../../Components/CartDetailsComponent/CartDetailsComponent";
import { toast } from "react-toastify";
import {
  Apiurl,
  GetLocalStorageParsed,
  parseData,
  stringifyData,
} from "../utils/page";
import axios from "axios";
import { useNavigate } from "react-router-dom";

import { ClipLoader, MoonLoader } from "react-spinners";
import "../../Components/CartDetailsComponent/CartDetailsComponent.css";
const CartDetails = () => {
  const FetchToken = GetLocalStorageParsed("AuthToken");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const router = useNavigate();

  const [getProfileData, setGetProfielData] = useState();

  const [cartItems, setCartItems] = useState();
  const [updatedBidValue, setUpdatedBidValue] = useState({});

  const [cartOrder, setCartOrder] = useState();
  const [loginToken, setLoginToken] = useState(FetchToken || null);
  const [cartOrderUpdate, setCartOrderUpdate] = useState(false);
  const [cartItemUpdate, setCartItemUpdate] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState();
  const [totalValue, setTotalValue] = useState();
  const [loading, setLoading] = useState(false);
  const [profileChange, setProfileChange] = useState(false);

  const [loadingFull, setLoadingFull] = useState(false);
  const [promoData, setPromoData] = useState();
  const [promoDataEmail, setPromoDataEmail] = useState();
  const [combinePromoData, setCombinePromoData] = useState();
  const [deliveryCharge, setDeliveryCharge] = useState();
  const [finalValue, setFinalValue] = useState();
  const [applyButton, setApplyButton] = useState(false);
  const [promoClickData, setPormoClickData] = useState();
  const [bidUpdate, setBidUpdate] = useState(false);
  const [paymentFailed, setPaymentFailed] = useState();

  // get Promo
  const getPromo = () => {
    const option = {
      method: "GET",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      url: `${Apiurl()}/api/PromoCode/GetPromoCodesLimitedUsers`,
    };
    axios(option)
      .then((e) => {
        setPromoData(parseData(e?.data?.result));
      })
      .catch((error) => {});
  };
  // get Promo
  const getDeliveryCharge = () => {
    const option = {
      method: "GET",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      url: `${Apiurl()}/api/SuperAdmin/GetDefaultSetting`,
    };
    axios(option)
      .then((e) => {
        const data = parseData(e?.data?.result);
        setDeliveryCharge(parseData(e?.data?.result));
      })
      .catch((error) => {});
  };

  const getPromoCodeByEmail = (item) => {
    const data = {
      email: getProfileData?.Email,
    };
    const option = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': `Bearer ${loginToken || " "}`
      },
      data: stringifyData(data),
      url: `${Apiurl()}/api/PromoCode/GetPromoCodesByEmail`,
    };
    axios(option)
      .then((e) => {
        setPromoDataEmail(parseData(e?.data?.result));
      })
      .catch((error) => {});
  };

  useEffect(() => {
    getPromo();
    getDeliveryCharge();
  }, []);
  useEffect(() => {
    if (getProfileData) {
      getPromoCodeByEmail();
    }
  }, [getProfileData]);
  useEffect(() => {
    const combine = [...(promoData || []), ...(promoDataEmail || [])];
    setCombinePromoData(combine);
  }, [promoDataEmail, promoData]);

  const handleUpdateBid = (item) => {
    if (!Number(updatedBidValue[item?.ProductId])) {
      toast.error("Please enter bid amount");
      return;
    }
    if (
      Number(updatedBidValue[item?.ProductId]) < Number(item?.RecommendedBid)
    ) {
      toast.error("Bid should not be less than recommended bid");
      return;
    }
    const data = {
      ProductId: item?.ProductId,
      BidAmount: updatedBidValue[item?.ProductId],
    };
    const option = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      data: stringifyData(data),
      url: `${Apiurl()}/api/Cart/AddBid`,
    };
    axios(option)
      .then((e) => {
        if (e?.data?.status === "OK") {
          toast.success(e?.data?.message);
        }

        if (e?.data?.status === "BadRequest") {
          toast.error(e?.data?.message);
        } else {
          setCartItemUpdate(true);
          setUpdatedBidValue("");
          setProfileChange(true);
        }
        // handleCartItems(token)
      })
      .catch((error) => {});
  };
  // delete cart order
  const handleRemoveCartOrder = (item) => {
    const option = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken}`,
      },
      url: `${Apiurl()}/api/Order/Remove?orderId=${item?.OrderId}`,
    };
    axios(option)
      .then((e) => {
        setCartOrderUpdate(true);
        if (e?.data?.status === "OK") {
          toast.success(e?.data?.message);
        }
        if (e?.data?.status === "BadRequest") {
          toast.error(e?.data?.message);
        }
      })
      .catch((error) => {});
  };
  // remove cart item
  const handleRemoveCartItem = (item) => {
    const data = {
      productId: item?.ProductId,
    };
    const option = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken}`,
      },
      data: stringifyData(data),
      url: `${Apiurl()}/api/Cart/Remove`,
    };
    axios(option)
      .then((e) => {
        if (e?.data?.status === "OK") {
          toast.success(e?.data?.message);
        }
        if (e?.data?.status === "BadRequest") {
          toast.error(e?.data?.message);
        }
        setCartItemUpdate(true);
        setProfileChange(true);
      })
      .catch((error) => {});
  };
  const handleChangeSelectedQuantity = (e, item) => {
    const { value } = e.target;
    if (item?.selectedQuantity === item?.AvailableQTY) {
      return;
    }
    if (/^\d*$/.test(value)) {
      const updatedList = cartOrder?.map((i) => {
        if (item?.OrderId === i?.OrderId) {
          const newQuantity = value === "" ? 0 : Number(value);
          // Ensure the newQuantity doesn't exceed AvailableQTY
          return {
            ...i,
            selectedQuantity:
              newQuantity > item?.AvailableQTY
                ? item?.AvailableQTY
                : newQuantity,
          };
        }
        return i;
      });
      setCartOrder(updatedList);
    }
  };
  const handleIncreaseSelectedQuantity = (item) => {
    if (item?.selectedQuantity === item?.AvailableQTY) {
      return; // Exit if selectedQuantity has already reached AvailableQTY
    } else {
      const updatedList = cartOrder?.map((i) => {
        if (item?.OrderId === i?.OrderId) {
          const newQuantity = item?.selectedQuantity + 1;
          return {
            ...i,
            selectedQuantity:
              newQuantity > item?.AvailableQTY
                ? item?.AvailableQTY
                : newQuantity,
          };
        }
        return i;
      });
      setCartOrder(updatedList);
    }
  };
  const handleDecreaseSelectedQuantity = (item) => {
    if (item?.selectedQuantity > 1) {
      const updatedList = cartOrder?.map((i) => {
        if (item?.OrderId === i?.OrderId) {
          return { ...i, selectedQuantity: item?.selectedQuantity - 1 };
        }
        return i;
      });
      setCartOrder(updatedList);
    }
  };

  const initPayment = async (e) => {
    // return
    let orderId = e.replace(/"/g, "");
    const options = {
      key: "rzp_live_SEIuC9F9Y9pG1r", //live
      // key: "rzp_test_0F6zCrTs97XdnP", //test
      amount: stringifyData(finalValue * 100),
      currency: "INR",
      name: "Shop Saverz",
      description: "Payment for Order or money for wallet",
      // order_id: orderId,
      prefill: {
        name: getProfileData?.Name,
        email: getProfileData?.Email,
        contact: getProfileData?.PhoneNumber,
      },
      handler: async (response) => {
        handleAfterPayment(response?.razorpay_payment_id, orderId);
      },
    };
    const paymentObject = new window.Razorpay(options);

    // Listen for payment success
    paymentObject.on("payment.success", (response) => {});

    // Listen for payment failure
    paymentObject.on("payment.failed", (response) => {
      setPaymentFailed(response);
    });
    paymentObject.open();
    setLoading(false);
  };
  const handleAfterPayment = (transId, orderId) => {
    setLoadingFull(true);

    const updatedList = cartOrder?.map((i) => {
      return {
        Unit: i?.selectedQuantity,
        ProductId: i?.ProductId,
      };
    });
    const data = {};
    data.OrderId = orderId;
    data.OrderNo = null;
    data.OrderDate = null;
    data.TotalAmount = finalValue;
    data.BillingAddress = null;
    data.DeliveryAddressId = null;
    data.Status = null;
    data.TransactionId = transId;
    data.OrderedProductIds = updatedList;
    data.IsPaymentSuccess = paymentFailed ? false : true;
    data.PaymentStatus = paymentFailed ? paymentFailed?.error?.description : " ";

    const option = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken}`,
      },
      data: stringifyData(data),
      url: `${Apiurl()}/api/Order/InsertOrderSummary`,
    };
    axios(option)
      .then((e) => {
        router(`/paymentsuccess/${finalValue}=${transId}`);
        setLoadingFull(false);
      })
      .catch((error) => {
        router(`/paymentfailed/${finalValue}=${transId}`);
        setLoadingFull(false);
      });
  };
  const handlePayment = () => {
    setLoading(true);
    const updatedList = cartOrder?.map((i) => {
      return {
        Unit: i?.selectedQuantity,
        ProductId: i?.ProductId,
      };
    });
    const data = {};
    data.OrderId = null;
    data.OrderNo = null;
    data.OrderDate = new Date();
    data.TotalAmount = finalValue;
    data.BillingAddress = null;
    data.DeliveryAddressId = selectedAddress?.Id;
    data.Status = "InProgress";
    data.TransactionId = null;
    // data.DeliveryCharges=deliveryCharge?.[0]?.DeliveryCharges;
    data.PromoCodeId = promoClickData?.Id;
    data.OrderedProductIds = updatedList;
    const option = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken}`,
      },
      data: stringifyData(data),
      url: `${Apiurl()}/api/Order/InsertOrderSummary`,
    };
    axios(option)
      .then((e) => {
        const data = JSON.parse(e?.data?.result);
        initPayment(data?.orderHeadId);
      })
      .catch((error) => {});
  };

  const handleApplyPromo = (item) => {
    setPormoClickData(item);
    setApplyButton(true);
    const final = totalValue + deliveryCharge?.[0]?.DeliveryCharges;
    const adjustedFinalValue = Math.max(0, final - (item?.MinAmount || 0)); // Ensures result is at least 0
    setFinalValue(adjustedFinalValue);
  };
  const handleRemovePromo = () => {
    setApplyButton(false);

    const final = totalValue + deliveryCharge?.[0]?.DeliveryCharges;
    setFinalValue(final);
  };
  return (
    <>
      <div
        style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}
      >
        <Header
          cartItems={cartItems}
          setCartItems={setCartItems}
          cartOrder={cartOrder}
          setCartOrder={setCartOrder}
          setCartOrderUpdate={setCartOrderUpdate}
          setCartItemUpdate={setCartItemUpdate}
          cartOrderUpdate={cartOrderUpdate}
          cartItemUpdate={cartItemUpdate}
          setGetProfielData={setGetProfielData}
          setLoginToken={setLoginToken}
          setProfileChange={setProfileChange}
          bidUpdate={bidUpdate}
          profileChange={profileChange}
        />

        {loadingFull ? (
          <div style={{ flex: "1" }} className="loader_full_back">
            <MoonLoader
              color="#198754"
              cssOverride={{}}
              loading
              size={50}
              speedMultiplier={0.6}
            />
          </div>
        ) : (
          <>
            <CartDetailsComponent
              cartOrder={cartOrder}
              cartItems={cartItems}
              handleRemoveCartOrder={handleRemoveCartOrder}
              handleRemoveCartItem={handleRemoveCartItem}
              setUpdatedBidValue={setUpdatedBidValue}
              handleUpdateBid={handleUpdateBid}
              updatedBidValue={updatedBidValue}
              handleChangeSelectedQuantity={handleChangeSelectedQuantity}
              handleIncreaseSelectedQuantity={handleIncreaseSelectedQuantity}
              handleDecreaseSelectedQuantity={handleDecreaseSelectedQuantity}
              handlePayment={handlePayment}
              setSelectedAddress={setSelectedAddress}
              selectedAddress={selectedAddress}
              setTotalValue={setTotalValue}
              totalValue={totalValue}
              loading={loading}
              combinePromoData={combinePromoData}
              deliveryCharge={deliveryCharge}
              handleApplyPromo={handleApplyPromo}
              applyButton={applyButton}
              setApplyButton={setApplyButton}
              handleRemovePromo={handleRemovePromo}
              finalValue={finalValue}
              promoClickData={promoClickData}
              setFinalValue={setFinalValue}
            />
          </>
        )}
        <Footer />
      </div>
    </>
  );
};
export default CartDetails;
